import TickerTape from "../components/widgets/TickerTape";
import AdvancedChart from "../components/widgets/AdvancedChart";
import SymbolOverview from "../components/widgets/SymbolOverview";
import MarketOverview from "../components/widgets/MarketOverview";
import { Link } from "react-router-dom";
import { useState } from "react";

const DEFAULTS = ["NASDAQ:AAPL", "NASDAQ:MSFT", "NASDAQ:TSLA", "AMEX:SPY"];

export default function ChartsPage() {
  const [symbol, setSymbol] = useState(DEFAULTS[0]);

  return (
    <main className="min-h-screen bg-slate-900 text-slate-100">
      <div className="mx-auto max-w-7xl p-4 sm:p-6">
        <div className="flex items-center justify-between mb-4">
          <h1 className="text-2xl font-semibold">Trading Charts</h1>
          <Link to="/" className="text-sky-400 hover:underline">← Back to home</Link>
        </div>

        <TickerTape />

        {/* 1) QUICK LOOK FIRST */}
        <section className="mt-10">
          <h2 className="text-xl font-semibold mb-3">Quick Look</h2>
          {/* Use a fixed-height wrapper when SymbolOverview uses autosize */}
          <div className="h-[400px]">
            <SymbolOverview />
          </div>
        </section>

        {/* 2) MARKET OVERVIEW SECOND */}
        <section className="mt-10">
          <h2 className="text-xl font-semibold mb-3">Market Overview</h2>
          <MarketOverview />
        </section>

        {/* 3) ADVANCED CHART THIRD */}
        <div className="mt-6 flex flex-wrap items-center gap-2">
          <label className="opacity-70">Symbol:</label>
          <select
            className="bg-slate-800 rounded px-3 py-2"
            value={symbol}
            onChange={(e) => setSymbol(e.target.value)}
          >
            {DEFAULTS.map((s) => (
              <option key={s} value={s}>{s}</option>
            ))}
            <option value="NASDAQ:QQQ">NASDAQ:QQQ</option>
            <option value="NYSE:VTI">NYSE:VTI</option>
            <option value="AMEX:ARKK">AMEX:ARKK</option>
          </select>
          <span className="text-xs opacity-70 ml-2">Tip: you can also change it inside the chart.</span>
        </div>

        <section className="mt-4">
          <AdvancedChart symbol={symbol} height={560} />
        </section>

        {/* Removed Lightweight Charts demo */}
      </div>
    </main>
  );
}
